module.exports = __webpack_public_path__ + "img/play-button-klein.eef8c51850b066a9f87a58924dc4a6ac.svg";